import Immutable from 'seamless-immutable'

import * as authenticationActions from 'external/reduxBits/authentication/actions'
import * as actions from './actions'

const initialState = Immutable.from({
  isFetching: false,
  error: false,
  loggedIn: false,
  isUpdating: false,
})

export default (state = initialState, { type, payload, error }) => {
  switch (type) {
    case authenticationActions.LOGOUT:
      return initialState

    case actions.REQUEST_USER_INFORMATION:
      return state.merge({
        isFetching: true,
        error: false,
      })
    case actions.RECEIVE_USER_INFORMATION:
      if (error) {
        return state.merge({
          error: true,
          isFetching: true,
        })
      }
      return state.merge({
        isFetching: false,
        error: false,
        loggedIn: true,
        ...payload,
      })
    case actions.REQUEST_UPDATE_ACCOUNT:
      return state.merge({
        isUpdating: true,
      })
    case actions.RECEIVE_UPDATE_ACCOUNT:
      return state.merge({
        isUpdating: false,
        propertyMap: { ...payload },
      })
    case actions.RECEIVE_UPDATE_ACCOUNT_ERROR:
      return state.merge({
        isUpdating: false,
      })
    default:
      return state
  }
}
